// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

import i2kFunctions from "i2kjslibrary";

import Functions from "@/utils/functions.js";

import Wait from 'i2kjslibrary/plugins/vuetify/wait/wait.js';

import Toast from './plugins/toast.js';

//import VTooltip from 'v-tooltip'

import Load from "./LOAD.js"
import 'material-design-icons-iconfont/dist/material-design-icons.css';
// Vuetify
Vue.use(Vuetify)

const opts = {
  theme: {
    /* dark: true, */
    themes: {
      light: {
        primary: /* '#b3d4fc', */'#2196F3',
      },
      dark: {
        primary: /* '#b3d4fc', */'#2196F3',
      },
    },
  },
  icons: {
    iconfont: 'md',
  },
}

// prototype
Vue.prototype.$functions = Functions;
Vue.prototype.$i2kFunctions = i2kFunctions;
Vue.prototype.$load = Load;

// Toast
Vue.use(Toast, {
  version: 2
})

// Tooltip
//Vue.use(VTooltip)

//Wait
Vue.use(Wait, {
  //background: "grey darken-1",
  version: 3
})

Vue.config.productionTip = false


/* eslint-disable no-new */
new Vue({
  render: h => h(App),
  router,
  store,
  vuetify: new Vuetify(opts)
}).$mount('#app')